import Icon from '@/components/Icon';
import NextAnchor from '@/components/ui/NextAnchor';
import Txt from '@/components/ui/Txt';
import { parseLocale } from '@/components/LanguageSelector/parseEntryLocales';
import { Entry, isEntry } from '@/lib/parsers/entries';
import { localeDefault } from '@/i18n/config';
import * as styles from './SearchBar.css';

type SearchBarResultProps = {
  item: Entry;
};

const SearchBarResult = (props: SearchBarResultProps) => {
  const { item } = props;
  const { title, uri, parent, siteHandle } = item;
  const parentTitle = parent?.title ?? '';

  // Construct the URL with the correct locale prefix
  // For default locale (en), don't add prefix (localePrefix: 'as-needed')
  // For other locales, add locale prefix
  const itemLocale = parseLocale(siteHandle);
  const href = itemLocale === localeDefault ? uri : `/${itemLocale}${uri}`;

  let typeLabel = '';

  switch (true) {
    case isEntry(item, 'article'):
      typeLabel = 'Article';
      break;
    case isEntry(item, 'profile'):
      typeLabel = 'Profile';
      break;
    case isEntry(item, 'service'):
      typeLabel = 'Service';
      break;
    case isEntry(item, 'sector'):
      typeLabel = 'Sector';
      break;
    case isEntry(item, 'product'):
      typeLabel = 'Product';
      break;
    default:
      typeLabel = 'Page';
      break;
  }

  return (
    <NextAnchor href={href} className={styles.resultItem}>
      <Txt className={styles.resultItemLabel}>
        {parentTitle && <span>{parentTitle} / </span>}
        {title}
      </Txt>
      <Txt className={styles.resultItemType}>{typeLabel}</Txt>
      <Icon className={styles.resultItemIcon} name="arrowRight" cx={{ color: 'accent' }} />
    </NextAnchor>
  );
};

export default SearchBarResult;
